export enum ViewModeEnum {
  LIST = 'LIST',
  TILE = 'TILE',
}
